import type { RootState } from "@/store/app/storeTypes";
import type { SparxsSearchIndexState } from "@/store/sparxsCatalog/searchIndexSlice";

export const selectSparxsSearchIndexPersistRehydrated = (
  state: RootState,
): boolean => {
  const p = (
    state.editor.sparxsSearchIndex as SparxsSearchIndexState & {
      _persist?: { rehydrated?: boolean };
    }
  )._persist;
  return p == null || p.rehydrated === true;
};
